import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="NK" transform="translate(11.000000, 5.000000)">
        <g transform="translate(11.000000, 26.000000)">
          <path
            d="M 6.006 35.229 L 6.006 11.67 L 6.421 11.67 L 18.555 35.229 L 24.707 35.229 L 24.707 0 L 18.701 0 L 18.701 23.413 L 18.286 23.413 L 6.177 0 L 0 0 L 0 35.229 L 6.006 35.229 Z M 38.257 35.229 L 38.257 24.512 L 41.357 20.557 L 50.977 35.229 L 59.058 35.229 L 46.143 15.552 L 58.276 0 L 50.952 0 L 38.623 16.04 L 38.257 16.04 L 38.257 0 L 31.665 0 L 31.665 35.229 L 38.257 35.229 Z"
            fill="currentColor"
          />
        </g>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
